// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"131":"1d0cb2fb","358":"2c653391"}[chunkId] + ".css";
};